import React from "react";
import SuspenseWrapper from "../../component/SuspenseWrapper";
const Payroll = React.lazy(() => import("@/pages/payroll/Index"));
const Settings = React.lazy(() => import("@/pages/payroll/settings/index"));
const Esic = React.lazy(() => import("@/pages/payroll/esic/index"));
const CtcBreakup = React.lazy(() => import("@/pages/payroll/ctcbreakups"));
const LwfSlab = React.lazy(() => import("@/pages/payroll/LWF"));
const PfLogic = React.lazy(() => import("@/pages/payroll/pflogic"));
const ReimbursementMaster = React.lazy(() =>
  import("@/pages/payroll/ReimbursementRelease")
);
const FbpMaster = React.lazy(() => import("@/pages/payroll/fbpMaster/index"));
const Paysheet = React.lazy(() => import("@/pages/payroll/paysheet/paysheet"));
const ExitPaysheet = React.lazy(() =>
  import("@/pages/payroll/paysheet/ExitPaysheet")
);
const Vpf = React.lazy(() => import("@/pages/payroll/vpf/index"));
const ItdMAster = React.lazy(() =>
  import("@/pages/payroll/itdMasterSetup/index")
);
const YtdReport = React.lazy(() => import("@/pages/payroll/ytdReport/index"));
const Loan = React.lazy(() => import("@/pages/payroll/loan/Loan"));
const ReimbursementApproval = React.lazy(() =>
  import("@/pages/payroll/reimbursementApproval/Index")
);
const Report = React.lazy(() => import("@/pages/payroll/report/index"));
const MonthImport = React.lazy(() =>
  import("@/pages/payroll/monthlyImports/Index")
);
const ItDeclaration = React.lazy(() => import("@/pages/payroll/ITD/Index"));
const Taxsheet = React.lazy(() => import("@/pages/payroll/taxSheet/index"));
const TdsSlab = React.lazy(() => import("@/pages/payroll/Tds"));
const FbpEmp = React.lazy(() => import("@/pages/salary/FbpEmployee"));
const FbpRelease = React.lazy(() => import("@/pages/payroll/fbpRelease/index"));
const Arrears = React.lazy(() => import("@/pages/payroll/arrears"));
const PTSlabs = React.lazy(() => import("@/pages/payroll/ptSlab/index"));
const LaravelPageEmbed = React.lazy(() =>
  import("@/components/common/laravelpage")
);
const ItDeclarationReport = React.lazy(() =>
  import("@/pages/payroll/itdReports/ITDReports")
);
const FbpReport = React.lazy(() => import("@/pages/payroll/fbpReport/index"));
const Payslip = React.lazy(() => import("@/pages/payroll/payslip/index"));
const FbaDetails = React.lazy(() => import("@/pages/payroll/fbaDetails"));
const FbpDetails = React.lazy(() => import("@/pages/payroll/fbpDetails/index"));
const FnFComponent = React.lazy(() =>
  import("@/pages/payroll/fnfComponent/Index")
);
const FnFVariables = React.lazy(() =>
  import("@/pages/payroll/fnfVariable/Index")
);
const AdminPOIReport = React.lazy(() =>
  import("@/pages/payroll/adminPOIReport/index")
);
const POIReport = React.lazy(() => import("@/pages/payroll/poiReport/index"));
const POIRelease = React.lazy(() => import("@/pages/payroll/poiRelease/index"));
const Form12BBReport = React.lazy(() => import("@/pages/salary/form12BBReport"));
const Form12BB = React.lazy(() => import("@/pages/salary/form12BB"));
const PayrollRouter = [
  {
    path: "/payroll",
    element: (
      <SuspenseWrapper>
        <LaravelPageEmbed />
      </SuspenseWrapper>
    ),
  },
  {
    path: "payrollSettings",
    element: (
      <SuspenseWrapper>
        <Settings />
      </SuspenseWrapper>
    ),
  },
  {
    path: "esic",
    element: (
      <SuspenseWrapper>
        <Esic />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ptSlab",
    element: (
      <SuspenseWrapper>
        <PTSlabs />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ctcBreakup",
    element: (
      <SuspenseWrapper>
        <CtcBreakup />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pflogic",
    element: (
      <SuspenseWrapper>
        <PfLogic />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LwfSlab",
    element: (
      <SuspenseWrapper>
        <LwfSlab />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reimbursementmMaster",
    element: (
      <SuspenseWrapper>
        <ReimbursementMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fbpMaster",
    element: (
      <SuspenseWrapper>
        <FbpMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "paysheet",
    element: (
      <SuspenseWrapper>
        <Paysheet />
      </SuspenseWrapper>
    ),
  },
  {
    path: "exitpaysheet",
    element: (
      <SuspenseWrapper>
        <ExitPaysheet />
      </SuspenseWrapper>
    ),
  },
  {
    path: "vpf",
    element: (
      <SuspenseWrapper>
        <Vpf />
      </SuspenseWrapper>
    ),
  },
  {
    path: "itdmaster",
    element: (
      <SuspenseWrapper>
        <ItdMAster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ytdreport",
    element: (
      <SuspenseWrapper>
        <YtdReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "loan",
    element: (
      <SuspenseWrapper>
        <Loan />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reimbursementapproval",
    element: (
      <SuspenseWrapper>
        <ReimbursementApproval />
      </SuspenseWrapper>
    ),
  },
  {
    path: "report",
    element: (
      <SuspenseWrapper>
        <Report />
      </SuspenseWrapper>
    ),
  },
  {
    path: "monthlyimport",
    element: (
      <SuspenseWrapper>
        <MonthImport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "itdeclaration",
    element: (
      <SuspenseWrapper>
        <ItDeclaration />
      </SuspenseWrapper>
    ),
  },

  {
    path: "itdeclarationreport",
    element: (
      <SuspenseWrapper>
        <ItDeclarationReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "taxsheet",
    element: (
      <SuspenseWrapper>
        <Taxsheet />
      </SuspenseWrapper>
    ),
  },
  {
    path: "tdsslab",
    element: (
      <SuspenseWrapper>
        <TdsSlab />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fbpemp",
    element: (
      <SuspenseWrapper>
        <FbpEmp />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fbprelease",
    element: (
      <SuspenseWrapper>
        <FbpRelease />
      </SuspenseWrapper>
    ),
  },
  {
    path: "arrears",
    element: (
      <SuspenseWrapper>
        <Arrears />
      </SuspenseWrapper>
    ),
  },

  {
    path: "fbpReport",
    element: (
      <SuspenseWrapper>
        <FbpReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "payslipAdmin",
    element: (
      <SuspenseWrapper>
        <Payslip />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fbpDetiails",
    element: (
      <SuspenseWrapper>
        <FbpDetails />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fnfComponent",
    element: (
      <SuspenseWrapper>
        <FnFComponent />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fnfVariables",
    element: (
      <SuspenseWrapper>
        <FnFVariables />
      </SuspenseWrapper>
    ),
  },
  {
    path: "fbaDetails",
    element: (
      <SuspenseWrapper>
        <FbaDetails />
      </SuspenseWrapper>
    ),
  },
  {
    path: "adminPOIReport",
    element: (
      <SuspenseWrapper>
        <AdminPOIReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "poiReport",
    element: (
      <SuspenseWrapper>
        <POIReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "poiReports",
    element: (
      <SuspenseWrapper>
        <Form12BBReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "form12bb",
    element: (
      <SuspenseWrapper>
        <Form12BB />
      </SuspenseWrapper>
    ),
  },
  {
    path: "poiRelease",
    element: (
      <SuspenseWrapper>
        <POIRelease />
      </SuspenseWrapper>
    ),
  },
];

export default PayrollRouter;
